export default "__VITE_ASSET__CyOos_lS__"